import { render, staticRenderFns } from "./Romanza_defaultSection.vue?vue&type=template&id=2fada059&scoped=true"
import script from "./Romanza_defaultSection.vue?vue&type=script&lang=ts"
export * from "./Romanza_defaultSection.vue?vue&type=script&lang=ts"
import style0 from "./Romanza_defaultSection.vue?vue&type=style&index=0&id=2fada059&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fada059",
  null
  
)

export default component.exports